import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ModifyIcon from '../../../../common/icons/modifyIcon';
import GarbageIcon from '../../../../common/icons/garbageIcon';

const useStyles = makeStyles((theme) => ({
  buttons: {
    width: '15%',
  },
  verticalDivider: {
    borderLeft: (props) =>
      props.main === 'true'
        ? `1px solid ${theme.palette.primary.main}`
        : `1px solid #BCBCBC`,
    height: '100%',
    width: '100%',
  },
  horizontalDivider: {
    borderBottom: (props) =>
      props.main === 'true'
        ? `1px solid ${theme.palette.primary.main}`
        : `1px solid #BCBCBC`,
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  button: {
    height: 40,
  },
  image: {
    height: 20,
    width: 20,
  },
}));

const AddressButtons = ({ ...props }) => {
  const { main, onClick, onClickEdit, disabled } = props;

  const handleDeleteClick = (event) => {
    onClick(event);
  };

  const classes = useStyles({ main: main });
  return (
    <div className={classes.buttons}>
      <div className={classes.verticalDivider}>
        <div className={classes.buttonContainer}>
          <IconButton
            data-cy="modifyButton"
            className={classes.button}
            onClick={onClickEdit}
          >
            <ModifyIcon size="20px" color="#464646" />
          </IconButton>
          <div className={classes.horizontalDivider}></div>
          <Tooltip
            title={disabled ? 'No puedes eliminar tu primera dirección' : ''}
            arrow
          >
            <span>
              <IconButton
                className={classes.button}
                onClick={handleDeleteClick}
                disabled={disabled}
                data-cy="deleteButton"
              >
                <GarbageIcon size="20px" color="#464646" />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

AddressButtons.propTypes = {
  main: PropTypes.string,
  onClick: PropTypes.func,
  onClickEdit: PropTypes.func,
  disabled: PropTypes.bool,
};

export default AddressButtons;
